module.exports = __webpack_public_path__ + "static/media/checkin_kiosk.4301f10a.png";